module.exports = __webpack_public_path__ + "static/double-backdrop.37f58980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/dialogs/double-backdrop.png
// module id = 2555
// module chunks = 105782860971035